import { forgotPasswordRoute } from '@lessonup/typescript-core/services';
import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { useAppServices } from '../../../components/appServices/AppServicesContext';
import { LoginButtons } from '../../../components/login/LoginButtons';
import PasswordLogin from '../../../components/login/PasswordLogin';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-object-type -- auto-generated TECH-258
const LoginForm: React.FC<{}> = (props) => {
  const { user } = useAppServices();
  const { t } = useTranslation('login');
  function handleForgotPassword() {
    window.open(forgotPasswordRoute(), '_parent');
  }

  return (
    <div className="login-options">
      <PasswordLogin
        loginWithPassword={user.loginWithPassword}
        handleForgotPassword={handleForgotPassword}
        source="standalone"
      />
      <div className="login__page-divider" />
      <div>
        <h3>{t('ssoHeader')}</h3>
        <LoginButtons source="page" />
      </div>
    </div>
  );
};

export default LoginForm;
